import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../../modules/infra/i18n';
import Item from './ListItem';
import * as shapes from '../shapes';

const List = ({ promoCodes, baseUrl, canModify }) => (
  <div className="c-wrapper">
    <div className="u-max-width-1050 u-margin-auto u-mv-">
      <div className="c-table-card c-table-new u-table-layout-fixed" display-if={promoCodes.length}>
        <div className="c-table-card__head">
          <div className="c-table-card__cell c-label">{t('settings:promo_codes.list.promo_name_header')}</div>
          <div className="c-table-card__cell c-label">{t('settings:promo_codes.list.value_header')}</div>
          <div className="c-table-card__cell c-label">{t('settings:promo_codes.list.first_appointment_only_header')}</div>
          <div className="c-table-card__cell c-label">{t('settings:promo_codes.list.one_time_promo_header')}</div>
          <div className="c-table-card__cell c-label">{t('settings:promo_codes.list.expiration_date_header')}</div>
          <div className="c-table-card__cell c-label">{t('settings:promo_codes.list.redemptions_header')}</div>
          <div className="c-table-card__cell c-label">{t('settings:promo_codes.list.total_redemption_value_header')}</div>
        </div>
      </div>
      <div className="c-table-card c-table-new u-table-layout-fixed" display-if={promoCodes.length}>
        {promoCodes.map((promoCode) => (
          <Item
            promoCode={promoCode}
            key={promoCode.id}
            baseUrl={baseUrl}
            disabled={!canModify}
          />
        ))}
      </div>
      <div className="c-heading c-heading--small u-mt" display-if={!promoCodes.length}>
        {t('settings:promo_codes.list.empty_message')}
      </div>
    </div>
  </div>
);
List.propTypes = {
  promoCodes: shapes.promoCodes,
  baseUrl: shapes.url,
  canModify: PropTypes.bool,
};
List.defaultProps = {
  promoCodes: [],
  baseUrl: '/settings/taxes',
  canModify: true,
};

export default List;
